import { defineComponent as c, createBlock as i, openBlock as o, unref as t, withCtx as l, createCommentVNode as s, createVNode as r, createTextVNode as b, toDisplayString as V, mergeProps as p, renderSlot as y, createElementBlock as u, createElementVNode as B, Fragment as _, renderList as g } from "vue";
import { Listbox as x, ListboxLabel as L, ListboxButton as h, ListboxOptions as k } from "@headlessui/vue";
import { useBindCx as $ } from "@scalar/use-hooks/useBindCx";
import N from "./ScalarListboxItem.vue.js";
import w from "../ScalarFloating/ScalarFloating.vue.js";
import C from "../ScalarFloating/ScalarFloatingBackdrop.vue.js";
const S = { class: "custom-scroll min-h-0 flex-1" }, D = /* @__PURE__ */ c({
  inheritAttrs: !1,
  __name: "ScalarListbox",
  props: {
    options: {},
    id: {},
    label: {},
    multiple: { type: Boolean },
    modelValue: {},
    placement: {},
    offset: { type: [Number, Object, Function] },
    resize: { type: Boolean },
    target: {},
    middleware: {},
    teleport: { type: [Boolean, String] }
  },
  emits: ["update:modelValue"],
  setup(v) {
    const { cx: d } = $();
    return (e, m) => (o(), i(t(x), {
      modelValue: e.modelValue,
      multiple: e.multiple,
      "onUpdate:modelValue": m[0] || (m[0] = (a) => e.$emit("update:modelValue", a))
    }, {
      default: l(({ open: a }) => [
        e.label ? (o(), i(t(L), {
          key: 0,
          class: "sr-only"
        }, {
          default: l(() => [
            b(V(e.label), 1)
          ]),
          _: 1
        })) : s("", !0),
        r(t(w), p(e.$props, {
          placement: e.placement ?? "bottom-start"
        }), {
          floating: l(({ width: f }) => [
            a ? (o(), u("div", p(
              {
                key: 0,
                style: { width: f }
              },
              t(d)(
                "relative flex max-h-[inherit] w-40 max-w-[inherit] rounded text-sm"
              )
            ), [
              B("div", S, [
                r(t(k), { class: "flex flex-col gap-0.75 p-0.75 -outline-offset-1" }, {
                  default: l(() => [
                    (o(!0), u(_, null, g(e.options, (n) => (o(), i(N, {
                      key: n.id,
                      option: n,
                      multiselect: e.multiple
                    }, null, 8, ["option", "multiselect"]))), 128))
                  ]),
                  _: 1
                })
              ]),
              r(t(C))
            ], 16)) : s("", !0)
          ]),
          default: l(() => [
            r(t(h), {
              id: e.id,
              as: "template"
            }, {
              default: l(() => [
                y(e.$slots, "default", { open: a })
              ]),
              _: 2
            }, 1032, ["id"])
          ]),
          _: 2
        }, 1040, ["placement"])
      ]),
      _: 3
    }, 8, ["modelValue", "multiple"]));
  }
});
export {
  D as default
};
